import * as Types from './types';

const getMultimedias = postingId => ({
  type: Types.GET_STEP_MULTIMEDIA,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/posting/STEP_MULTIMEDIA/${postingId}`,
    method: 'GET'
  }
});

const previewImageStorage = (data, itemId, postingId = null) => ({
  type: Types.PREVIEW_STORAGE_IMAGE,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorImg',
    path: `/preview?postingId=${postingId}`,
    method: 'POST',
    body: data,
    itemId
  }
});

const resetPreviewStorage = itemId => ({
  type: Types.RESET_PREVIEW_STORAGE,
  payload: { itemId }
});

const validateVideo360 = url => ({
  type: Types.VALIDATE_VIDEO_360,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorImg',
    path: '/validatetour',
    method: 'POST',
    query: { url }
  }
});

const deleteMultimedia = (id, multimediaType) => ({
  type: Types.DELETE_MULTIMEDIA,
  payload: {
    id,
    type: multimediaType
  }
});

const addErrorMultimedia = (id, multimediaType, keyError) => ({
  type: Types.ADD_ERROR_MULTIMEDIA,
  payload: {
    id,
    type: multimediaType,
    keyError
  }
});

const updateMultimedia = (multimedia, multimediaType) => ({
  type: Types.UPDATE_MULTIMEDIA,
  payload: {
    multimedia,
    type: multimediaType
  }
});

const addMultimedia = (multimedia, multimediaType) => ({
  type: Types.ADD_MULTIMEDIA,
  payload: {
    multimedia,
    type: multimediaType
  }
});

const moveMultimedia = (dragIndex, hoverIndex, multimediaType) => ({
  type: Types.MOVE_MULTIMEDIA,
  payload: {
    dragIndex,
    hoverIndex,
    type: multimediaType
  }
});

const bulkActionMultimedia = (actions = []) => {
  return {
    type: Types.BULK_ACTION_MULTIMEDIA,
    meta: {
      bulk: true,
      data: [...actions]
    }
  };
};

const cleanMultimedia = multimediaType => ({
  type: Types.CLEAN_MULTIMEDIA,
  payload: {
    type: multimediaType
  }
});

const cleanGetMultimedia = () => ({
  type: Types.CLEAN_MULTIMEDIA_GET
});

const resetInfo = () => ({
  type: Types.RESET_INFO
});

export {
  getMultimedias,
  updateMultimedia,
  addMultimedia,
  deleteMultimedia,
  bulkActionMultimedia,
  moveMultimedia,
  addErrorMultimedia,
  cleanMultimedia,
  validateVideo360,
  previewImageStorage,
  resetPreviewStorage,
  resetInfo,
  cleanGetMultimedia
};
